export function SelfRepairTool({ image, name }) {
    return (
        <div className="flex items-center space-x-3 bg-gray-100 rounded-lg p-3">
            {image && (
                <img
                    className="w-auto h-8 object-cover"
                    src={image}
                />
            )}
            <span>{name}</span>
        </div>
    );
}
